import styled from "styled-components";

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
`;

export const TableHeader = styled.thead`
  border-bottom: 1px solid #e5e7eb;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  border-bottom: 1px solid #e5e7eb;
  &:hover {
    background: #f9fafb;
  }
`;

export const TableHead = styled.th`
  text-align: left;
  padding: 10px 16px;
  font-weight: 600;
  color: #6b7280;
`;

export const TableCell = styled.td`
  padding: 10px 16px;
  vertical-align: middle;
`;

